import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AppTitleComponent } from '../core/components/app-title/app-title.component';
import { NavigateBackDirective } from '../toExtract/back-navigation/navigate-back.directive';

@Component({
  selector: 'pd-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    NavigateBackDirective,
    MatIconModule,
    AppTitleComponent,
    RouterLink,
  ],
})
export class PrivacyPolicyComponent {}
